// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Data2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Data2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.833 6.667h-2.5c-.916 0-1.666-.75-1.666-1.667V3.333c0-.916.75-1.666 1.666-1.666h2.5c.917 0 1.667.75 1.667 1.666V5c0 .917-.75 1.667-1.667 1.667ZM17.333 5.833h-3c-.55 0-1-.45-1-1V3.5c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1.333c0 .55-.45 1-1 1ZM17.333 12.083h-3c-.55 0-1-.45-1-1V9.75c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1.333c0 .55-.45 1-1 1Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.333 11.042a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625h-2.291v-5h2.291a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625H7.5a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625h2.292V15a2.29 2.29 0 0 0 2.291 2.292h1.25a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625h-1.25A1.042 1.042 0 0 1 11.042 15v-3.958h2.291Z",
  opacity: 0.96
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.333 18.333h-3c-.55 0-1-.45-1-1V16c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1.333c0 .55-.45 1-1 1Z"
}));
export default Data2Icon;